/* tslint:disable */

declare var Object: any;
export interface VolumeDiscountRateInterface {
  "partnerId": string;
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "unit": string;
  "minimum": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "id"?: number;
}

export class VolumeDiscountRate implements VolumeDiscountRateInterface {
  "partnerId": string;
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "unit": string;
  "minimum": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "id": number;
  constructor(data?: VolumeDiscountRateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VolumeDiscountRate`.
   */
  public static getModelName() {
    return "VolumeDiscountRate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VolumeDiscountRate for dynamic purposes.
  **/
  public static factory(data: VolumeDiscountRateInterface): VolumeDiscountRate{
    return new VolumeDiscountRate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VolumeDiscountRate',
      plural: 'VolumeDiscountRates',
      path: 'VolumeDiscountRates',
      idName: 'id',
      properties: {
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "merchantType": {
          name: 'merchantType',
          type: 'number'
        },
        "paymentType": {
          name: 'paymentType',
          type: 'number'
        },
        "discount": {
          name: 'discount',
          type: 'number',
          default: 0
        },
        "unit": {
          name: 'unit',
          type: 'string',
          default: 'P'
        },
        "minimum": {
          name: 'minimum',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
